import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "flex flex-col gap-5" };
const _hoisted_2 = {
    class: "text-sm text-(--colors-text-body-subtle)",
    "data-testid": "donation-settings-identity-required-hint"
};
const _hoisted_3 = { "data-testid": "donation-settings-identity-signature" };
import { Alert, ImageUploadInput, TextInput } from "@eudonet/opal";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { ORGANIZATION_QUALIFICATION_MAX_LENGTH, RECEIPT_OBJECT_MAX_LENGTH, SIGNATORY_NAME_MAX_LENGTH, SIGNATURE_MAX_BYTES, } from "@/modules/workspace/public";
import { useWorkspaceCountry } from "@/shared/composables/useWorkspaceCountry";
import DonationSettingsBlockState from "./DonationSettingsBlockState.vue";
import DonationSettingsReadOnlyField from "./DonationSettingsReadOnlyField.vue";
import DonationSettingsFieldError from "./DonationSettingsFieldError.vue";
import DonationSettingsSection from "./DonationSettingsSection.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DonationSettingsIdentityTab',
    props: {
        settings: {},
        errors: {},
        isLoading: { type: Boolean },
        loadError: { type: Boolean }
    },
    emits: ["retry", "update:field", "signature:upload", "signature:remove", "signature:cancel"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const { t } = useI18n();
        const workspaceCountry = useWorkspaceCountry();
        // The label is the country name, never a code the donor would not read: a country the workspace
        // seam starts returning needs its key under `identity.countries`, or the raw key renders.
        const countryLabel = computed(() => t(`finance.taxReceipts.settings.identity.countries.${workspaceCountry.value}`));
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(DonationSettingsBlockState, {
                "is-loading": __props.isLoading,
                "load-error": __props.loadError,
                "error-key": "workspace.settings.loadError",
                "test-id": "donation-settings-legal-info",
                onRetry: _cache[7] || (_cache[7] = ($event) => (emit('retry')))
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(DonationSettingsSection, {
                            title: _ctx.$t('finance.donationModuleSettings.identity.organisationTitle'),
                            subtitle: _ctx.$t('finance.taxReceipts.settings.identity.subtitle'),
                            "test-id": "donation-settings-identity-organisation"
                        }, {
                            default: _withCtx(() => [
                                (__props.errors.form)
                                    ? (_openBlock(), _createBlock(_unref(Alert), {
                                        key: 0,
                                        color: "danger",
                                        message: _ctx.$t(__props.errors.form),
                                        "data-testid": "donation-settings-identity-form-error"
                                    }, null, 8 /* PROPS */, ["message"]))
                                    : _createCommentVNode("v-if", true),
                                _createVNode(DonationSettingsReadOnlyField, {
                                    label: _ctx.$t('finance.taxReceipts.settings.identity.nameLabel'),
                                    value: __props.settings.name,
                                    editable: false,
                                    "test-id": "donation-settings-identity-name"
                                }, null, 8 /* PROPS */, ["label", "value"]),
                                _createVNode(DonationSettingsReadOnlyField, {
                                    label: _ctx.$t('workspace.settings.fields.siren'),
                                    value: __props.settings.siren,
                                    "test-id": "donation-settings-identity-siren"
                                }, null, 8 /* PROPS */, ["label", "value"]),
                                _createVNode(DonationSettingsReadOnlyField, {
                                    label: _ctx.$t('workspace.settings.fields.siret'),
                                    value: __props.settings.siret,
                                    "test-id": "donation-settings-identity-siret"
                                }, null, 8 /* PROPS */, ["label", "value"]),
                                _createVNode(DonationSettingsReadOnlyField, {
                                    label: _ctx.$t('finance.taxReceipts.settings.identity.rnaLabel'),
                                    value: __props.settings.rna,
                                    "test-id": "donation-settings-identity-rna"
                                }, null, 8 /* PROPS */, ["label", "value"]),
                                _createVNode(DonationSettingsReadOnlyField, {
                                    label: _ctx.$t('finance.taxReceipts.settings.identity.countryLabel'),
                                    value: countryLabel.value,
                                    editable: false,
                                    "test-id": "donation-settings-identity-country"
                                }, null, 8 /* PROPS */, ["label", "value"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["title", "subtitle"]),
                        _createVNode(DonationSettingsSection, {
                            title: _ctx.$t('finance.donationModuleSettings.identity.signatoryTitle'),
                            "test-id": "donation-settings-identity-signatory"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("finance.taxReceipts.settings.requiredFieldsHint")), 1 /* TEXT */),
                                _createVNode(_unref(TextInput), {
                                    "model-value": __props.settings.signatoryFunction,
                                    label: _ctx.$t('workspace.settings.fields.signatoryFunction'),
                                    hint: _ctx.$t('workspace.settings.fields.signatoryFunctionHint'),
                                    error: __props.errors.signatoryFunction ? _ctx.$t(__props.errors.signatoryFunction) : undefined,
                                    maxlength: 100,
                                    required: "",
                                    "full-width": "",
                                    "data-testid": "donation-settings-identity-signatory-function",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (emit('update:field', 'signatoryFunction', $event)))
                                }, null, 8 /* PROPS */, ["model-value", "label", "hint", "error"]),
                                _createVNode(_unref(TextInput), {
                                    "model-value": __props.settings.signatoryName,
                                    label: _ctx.$t('workspace.settings.fields.signatoryName'),
                                    hint: _ctx.$t('workspace.settings.fields.signatoryNameHint'),
                                    error: __props.errors.signatoryName ? _ctx.$t(__props.errors.signatoryName) : undefined,
                                    maxlength: _unref(SIGNATORY_NAME_MAX_LENGTH),
                                    required: "",
                                    "full-width": "",
                                    "data-testid": "donation-settings-identity-signatory-name",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (emit('update:field', 'signatoryName', $event)))
                                }, null, 8 /* PROPS */, ["model-value", "label", "hint", "error", "maxlength"]),
                                _createVNode(_unref(TextInput), {
                                    "model-value": __props.settings.receiptObject,
                                    label: _ctx.$t('workspace.settings.fields.receiptObject'),
                                    hint: _ctx.$t('workspace.settings.fields.receiptObjectHint'),
                                    error: __props.errors.receiptObject ? _ctx.$t(__props.errors.receiptObject) : undefined,
                                    maxlength: _unref(RECEIPT_OBJECT_MAX_LENGTH),
                                    required: "",
                                    "full-width": "",
                                    "data-testid": "donation-settings-identity-receipt-object",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (emit('update:field', 'receiptObject', $event)))
                                }, null, 8 /* PROPS */, ["model-value", "label", "hint", "error", "maxlength"]),
                                _createVNode(_unref(TextInput), {
                                    "model-value": __props.settings.organizationQualification,
                                    label: _ctx.$t('workspace.settings.fields.organizationQualification'),
                                    hint: _ctx.$t('workspace.settings.fields.organizationQualificationHint'),
                                    error: __props.errors.organizationQualification ? _ctx.$t(__props.errors.organizationQualification) : undefined,
                                    maxlength: _unref(ORGANIZATION_QUALIFICATION_MAX_LENGTH),
                                    required: "",
                                    "full-width": "",
                                    "data-testid": "donation-settings-identity-organization-qualification",
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (emit('update:field', 'organizationQualification', $event)))
                                }, null, 8 /* PROPS */, ["model-value", "label", "hint", "error", "maxlength"]),
                                _createElementVNode("div", _hoisted_3, [
                                    _createVNode(_unref(ImageUploadInput), {
                                        "image-url": __props.settings.signatureUrl ?? undefined,
                                        "image-alt": _ctx.$t('workspace.settings.signature.imageAlt'),
                                        label: _ctx.$t('workspace.settings.signature.label'),
                                        "edit-button-label": _ctx.$t('workspace.settings.signature.editButton'),
                                        "modal-title": _ctx.$t('workspace.settings.signature.modalTitle'),
                                        "cancel-button-label": _ctx.$t('workspace.settings.signature.cancelButton'),
                                        "upload-button-label": _ctx.$t('workspace.settings.signature.uploadButton'),
                                        "remove-button-label": _ctx.$t('workspace.settings.signature.removeButton'),
                                        "browse-button-text": _ctx.$t('workspace.settings.signature.browseButton'),
                                        placeholder: _ctx.$t('workspace.settings.signature.placeholder'),
                                        "max-file-size-text": _ctx.$t('workspace.settings.signature.maxFileSizeText'),
                                        "file-type-error-text": _ctx.$t('workspace.settings.errors.signatureFormat'),
                                        "file-size-error-text": _ctx.$t('workspace.settings.errors.signatureSize'),
                                        accept: "image/png,image/jpeg",
                                        "max-file-size": _unref(SIGNATURE_MAX_BYTES),
                                        required: "",
                                        "show-alert": false,
                                        onUpload: _cache[4] || (_cache[4] = ($event) => (emit('signature:upload', $event))),
                                        onRemove: _cache[5] || (_cache[5] = ($event) => (emit('signature:remove'))),
                                        onCancel: _cache[6] || (_cache[6] = ($event) => (emit('signature:cancel')))
                                    }, null, 8 /* PROPS */, ["image-url", "image-alt", "label", "edit-button-label", "modal-title", "cancel-button-label", "upload-button-label", "remove-button-label", "browse-button-text", "placeholder", "max-file-size-text", "file-type-error-text", "file-size-error-text", "max-file-size"]),
                                    _createVNode(DonationSettingsFieldError, {
                                        message: __props.errors.signature ? _ctx.$t(__props.errors.signature) : undefined,
                                        class: "mt-2",
                                        "test-id": "donation-settings-identity-signature-error"
                                    }, null, 8 /* PROPS */, ["message"])
                                ])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["title"])
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["is-loading", "load-error"]));
        };
    }
});
